export default {
  methods: {
    userHasAnyRole(roles) {
      if (this.rolesAcreditados === undefined) {
        throw new Error(
          `${this.$options.name} must include useSession and useAcreditacionServicio mixins`
        )
      }

      return this.rolesAcreditados.some(rol => roles.includes(rol.codigo))
    },
  },
}
